import React from 'react'

const RelatedLink = ({ text, url }) => {
  if (!(text && url)) {
    return null
  }

  return (
    <a
      href={url}
      className="font-bold text-12 text-depths no-underline"
    >
      {text}
    </a>
  )
}

export default RelatedLink
